import Button from '@/components/base/Button';

interface BankAccountStepProps {
  method: 'account' | 'phone';
  account: string;
  onAccount: (value: string) => void;
  onContinue: () => void;
  canContinue: boolean;
}

/**
 * "Please enter the recipient's details" — the account number (or the phone
 * number linked to the account) for the bank chosen in the previous step.
 */
export default function BankAccountStep({
  method,
  account,
  onAccount,
  onContinue,
  canContinue,
}: BankAccountStepProps) {
  const isPhone = method === 'phone';

  return (
    <div className="space-y-6">
      <h3 className="font-heading text-lg font-semibold text-foreground-950">
        Please enter the recipient&rsquo;s details
      </h3>

      <div>
        <label
          htmlFor="flow-account"
          className="text-xs font-label font-medium text-foreground-500"
        >
          {isPhone ? 'Phone number' : 'Account number'}
        </label>
        <input
          id="flow-account"
          value={account}
          inputMode="numeric"
          onChange={(event) => onAccount(event.target.value.replace(/\D/g, ''))}
          placeholder={
            isPhone ? 'Enter the phone number linked to the account' : 'Enter their account number'
          }
          className="mt-1 h-10 w-full border-b border-background-300 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-500 focus:outline-none"
        />
      </div>

      <Button size="sm" onClick={onContinue} disabled={!canContinue}>
        Continue
      </Button>
    </div>
  );
}